import * as React from "react"
import { cn } from "../../lib/utils"

export interface LabelProps
  extends React.LabelHTMLAttributes<HTMLLabelElement> {
  requiredIndicator?: boolean
}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, children, requiredIndicator, ...props }, ref) => (
    <label
      ref={ref}
      className={cn(
        "text-label font-semibold uppercase tracking-wide text-foreground-subtle",
        className,
      )}
      {...props}
    >
      {children}
      {requiredIndicator && (
        <span className="ml-1 text-danger" aria-hidden="true">
          *
        </span>
      )}
    </label>
  ),
)
Label.displayName = "Label"
